import React from "react"
import { Box } from "@mui/material"

const LoginError = ({ msg }) => {
  if (!msg) return null
  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "red",
        color: "white",
        borderRadius: "4px",
        p: 1,
      }}>
      {msg}
    </Box>
  )
}

export default LoginError
